module.exports = "/assets/images/8effb80ba7c02027f468ca2e476da53d.svg";